// Copyright (c) 2022 by Move Closer

import EasyMDE from 'easymde'

import { headingShortcut } from './shortcuts'

/**
 * Base `<MarkdownEditor>` configuration
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
const baseConfig = {
  autoDownloadFontAwesome: false,
  indentWithTabs: false,
  spellChecker: false,
  tabSize: 4
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const EasyMDESimpleConfig: EasyMDE.Options = {
  ...baseConfig,
  toolbar: [
    'bold', 'italic', 'strikethrough',
    '|', headingShortcut, 'unordered-list', 'ordered-list',
    '|', 'preview'
  ]
}
